// extracted by mini-css-extract-plugin
export default {"ad":"index_ad_pUBXq","box":"index_box_lrc6F","footer":"index_footer_s-lxE"};